import { Injectable } from '@angular/core';
import * as DOMPurify from 'dompurify';
@Injectable({
  providedIn: 'root',
})
export class XssSanitizerService {
  // sanitizeEditorInput(value: string): string {
  //     const parser = new DOMParser();
  //   const decoded = parser.parseFromString(value, 'text/html').documentElement.textContent || value;

  //   return DOMPurify.sanitize(decoded,{
  //   ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'ul', 'ol', 'li', 'br', 'span', 'div', 'img'], // customize allowed tags
  //   ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'class', 'style'],
  //     }).trim();
    
  //   return value;
  // }

 


//   sanitizeInput(value: string): string {
//     const parser = new DOMParser();
//   const decoded = parser.parseFromString(value, 'text/html').body.textContent || value;
//   const cleaned = DOMPurify.sanitize(decoded, {
//     ALLOWED_TAGS: [],
//     ALLOWED_ATTR: []
//   }).trim();

//   return cleaned || '';
// }

// sanitizeInput(value: string): string {
//   if (!value || typeof value !== 'string') return '';

//   // Use DOMPurify with NO allowed tags to strip all tags but keep text
//   const clean = DOMPurify.sanitize(value, {
//     ALLOWED_TAGS: [],
//     ALLOWED_ATTR: [],
//   });

//   // Trim result to remove extra spaces
//   return clean.trim();
// }

// sanitizeInput(value: string): string {
//   if (!value || typeof value !== 'string') return '';

//   // Check if input contains <script> tags or any HTML tags
//   const containsScriptTag = /<script.*?>[\s\S]*?<\/script>/i.test(value);
//   const containsHtmlTags = /<\/?[a-z][\s\S]*?>/i.test(value);

//   if (containsScriptTag) {
//     // Block script tag input entirely
//     console.warn('Blocked script tag input:', value);
//     return '';
//   }

//   // If other HTML tags are present, sanitize them away (strip tags)
//   if (containsHtmlTags) {
//     const cleaned = DOMPurify.sanitize(value, {
//       ALLOWED_TAGS: [],  // no tags allowed
//       ALLOWED_ATTR: [],  // no attributes allowed
//     }).trim();

//     return cleaned;
//   }

//   // No HTML tags, just sanitize to remove any dangerous chars if needed
//   const cleaned = DOMPurify.sanitize(value, {
//     ALLOWED_TAGS: [],
//     ALLOWED_ATTR: [],
//   }).trim();

//   return cleaned;
// }




   sanitizeImageInput(image: any): any {
  const allowedMimeTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

  // Base64 image string
  if (typeof image === 'string' && image.startsWith('data:image/')) {
    const mimeMatch = image.match(/^data:(image\/[a-zA-Z+]+);base64,/);
    const mimeType = mimeMatch ? mimeMatch[1].toLowerCase() : '';

    const base64Data = image.split(',')[1] || '';
    const isValidBase64 = /^[A-Za-z0-9+/]+={0,2}$/.test(base64Data);
    const isRealImage = base64Data.length > 100;

    if (!allowedMimeTypes.includes(mimeType) || !isValidBase64 || !isRealImage) {
      return ''; 
    }

    return image;
  }

  // URL string (allow query strings / paths common on CDNs)
  if (typeof image === 'string' && /^https?:\/\//i.test(image)) {
    const imageUrlPattern = /\.(png|jpe?g|gif|webp)(\?|$|#)/i;
    if (imageUrlPattern.test(image) || /\/(uploads|images|media|storage|tier)/i.test(image)) {
      return image;
    }
  }

  // File object (no validation needed as per your request)
  if (image instanceof File) {
    return image;
  }

  // Unknown type → clear it
  return '';
}


sanitizeFormValues(obj: any): any {
  if (obj === null || obj === undefined) return obj;
  if (typeof obj === 'string') {
    return DOMPurify.sanitize(obj);
  }
  if (Array.isArray(obj)) {
    return obj.map(item => this.sanitizeFormValues(item));
  }
  if (typeof obj === 'object') {
    const sanitizedObj: any = {};
    for (const key of Object.keys(obj)) {
      sanitizedObj[key] = this.sanitizeFormValues(obj[key]);
    }
    return sanitizedObj;
  }
  return obj;
}

sanitizeInput(value: string): string {
  if (!value || typeof value !== 'string') return '';

  const containsScriptTag = /<script.*?>[\s\S]*?<\/script>/i.test(value);
  const containsHtmlTags = /<\/?[a-z][\s\S]*?>/i.test(value);

  if (containsScriptTag) {
    console.warn('Blocked script tag input:', value);
    return '';
  }

  if (containsHtmlTags) {
    return DOMPurify.sanitize(value, {
      ALLOWED_TAGS: [],
      ALLOWED_ATTR: [],
    }).trim();
  }

  return DOMPurify.sanitize(value, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
  }).trim();
}

// sanitizeEditorInput(value: string): string {
//   // Optionally block script tags here as well
//   const containsScriptTag = /<script.*?>[\s\S]*?<\/script>/i.test(value);
//   if (containsScriptTag) {
//     console.warn('Blocked script tag in editor input:', value);
//     return '';
//   }

//   const parser = new DOMParser();
//   const decoded = parser.parseFromString(value, 'text/html').documentElement.textContent || value;

//   return DOMPurify.sanitize(decoded, {
//     ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'ul', 'ol', 'li', 'br', 'span', 'div', 'img'],
//     ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'class', 'style'],
//   }).trim();
// }


sanitizeEditorInput(value: string): string {
  // Remove real <script> tags
  value = value.replace(/<script.*?>[\s\S]*?<\/script>/gi, '');

  // Remove encoded &lt;script&gt; tags
  value = value.replace(/&lt;script.*?&gt;[\s\S]*?&lt;\/script&gt;/gi, '');

  // Sanitize the rest (allowing only safe tags)
  return DOMPurify.sanitize(value, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'ul', 'ol', 'li', 'br', 'span', 'div', 'img'],
    ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'class', 'style'],
   FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'link'],
    FORBID_ATTR: ['style', 'onerror', 'onclick', 'onload', 'onmouseover'],
  }).trim();
}


sanitizeEditorPostInput(value: string): string {
  if (!value || typeof value !== 'string') return '';

  // ✅ Step 1: Decode HTML entities like &lt;script&gt;
  const decodeHtmlEntities = (input: string): string => {
    const txt = document.createElement('textarea');
    txt.innerHTML = input;
    return txt.value;
  };

  value = decodeHtmlEntities(value); // Now value is <p><script>alert('hello');</script></p>

  // ✅ Step 2: Strip all <script> tags
  value = value.replace(/<script.*?>[\s\S]*?<\/script>/gi, '');

  // ✅ Step 3: Sanitize remaining HTML
  const cleaned = DOMPurify.sanitize(value, {
    ALLOWED_TAGS: ['p', 'b', 'i', 'em', 'strong', 'a', 'ul', 'ol', 'li', 'br', 'span', 'div'],
    ALLOWED_ATTR: ['href', 'title', 'class', 'src', 'alt'],
    FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'style'],
    FORBID_ATTR: ['onerror', 'onclick', 'onload', 'onmouseover', 'style']
  }).trim();

  return cleaned === '' || cleaned === '<p></p>' ? '' : cleaned;
}

















sanitizePayload(obj: any): any {
  if (!obj || typeof obj !== 'object') return obj;

  const sanitized: any = Array.isArray(obj) ? [] : {};

  for (const key of Object.keys(obj)) {
    const value = obj[key];

    // 🔸 Image field
    if (key.toLowerCase().includes('image')) {
      sanitized[key] = this.sanitizeImageInput(value);
    }

    // 🔸 CKEditor field
    else if (key.toLowerCase().includes('editor') || key.toLowerCase().includes('html')) {
      sanitized[key] = this.sanitizeEditorInput(value);
    }

    // 🔸 String input field
    else if (typeof value === 'string') {
      sanitized[key] = this.sanitizeInput(value);
    }

    // 🔸 Array or nested object
    else if (typeof value === 'object') {
      sanitized[key] = this.sanitizePayload(value);
    }

    // 🔸 Fallback
    else {
      sanitized[key] = value;
    }
  }

  return sanitized;
}


// if (typeof obj === 'object' && obj !== null) {
//     const cleanObj = {};
//     for (const key in obj) {
//       cleanObj[key] = this.sanitizeFormValues(obj[key]);
//     }
//     return cleanObj;
//   }
}
